import { Loading, StringHelpers, SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';

export const Rater = ({ level, onChange, benchmark, hideOutOf, outOf, hoverText, loading }) => {
    const [editMode, setEditMode] = React.useState(false);
    const rater = React.useRef(null);
    const user = useSelector(state => state.user.user);
    const ratings = user.companySettings?.display?.ratingRange || 5;

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClick, false);

        return () => {
            document.removeEventListener('mousedown', handleClick, false);
        };
    }, []);

    const setRating = value => {
        if (editMode) {
            setEditMode(false);
            const newLevel = value;
            if (level !== newLevel) {
                onChange(newLevel);
            }
        }
    };

    const handleClick = e => {
        if (rater.current && !rater.current.contains(e.target)) {
            setEditMode(false);
        }
    };

    const onClick = onChange ? () => setEditMode(true) : null;

    const clickToEdit = SystemText('User121/Competency/Rater/Click');
    const notAvail = SystemText('User121/Competency/Rater/NA');

    const rating =
        level === 0 ? (
            <span
                title={onChange ? clickToEdit : ''}
                key="rating0"
                onClick={onClick}
                className={`unrated ${onChange ? 'pointer' : ''}`}
            >
                <span className="visible-lg">{notAvail}</span>
                <span className="hidden-lg">-</span>
            </span>
        ) : (
            <span
                style={{ textWrap: 'wrap' }}
                title={onChange ? clickToEdit : ''}
                key="rating0"
                onClick={onClick}
                className={onChange ? 'pointer' : ''}
            >
                <div className="flex flex-center flex-wrap justify-end">
                    <span className="text-rating text-lg no-wrap">
                        {loading ? <i className="fa fa-spin fa-cog" /> : <b>{level}</b>}
                        {!hideOutOf && <span className="mr1 ml1 text-xs">/</span>}
                    </span>
                    {!hideOutOf && <span className="text-xs">{outOf || ratings}</span>}
                </div>
            </span>
        );

    const editor = (
        <span key="rating-editor" className="rating-editor">
            <div ref={rater}>
                <div className="rater-ctrl" onClick={() => setEditMode(false)}>
                    <span className="mr5">{level}</span>
                    <i className="fa fa-chevron-down" />
                </div>
                {[...Array(ratings).keys()].map(r => {
                    r++;
                    return (
                        <div className="option" key={`rating-${r}`} onClick={() => setRating(r)}>
                            {r}
                        </div>
                    );
                })}
            </div>
        </span>
    );

    let bar = 'disabled';
    let colour = '';
    if (benchmark < 34 && benchmark >= 0) {
        colour = 'red';
        bar = 'danger';
    } else if (benchmark >= 67) {
        colour = 'green';
        bar = 'success';
    } else if (benchmark >= 34) {
        colour = 'orange';
        bar = 'warning';
    }

    return (
        <div
            data-testid="button-competencies-rater"
            className={`text-right ${onChange ? 'competencies-rater' : ''}`}
            // style={{ height: user?.show_Benchmarks ? '25px' : '15px' }}
        >
            {editMode ? editor : rating}
            {/* {benchmark !== null && <div style={{ width: '100%', backgroundColor: '#ff0000', height: '3px' }}></div>} */}
            {user?.show_Benchmarks && (
                <div
                    className="progress progress-xs"
                    style={{ display: 'block', width: '100%' }}
                    title={
                        hoverText ||
                        `${benchmark}${StringHelpers.getOrdinalSuffix(benchmark)} ${SystemText(
                            'User121/Benchmark/Percentile'
                        )}`
                    }
                >
                    <div
                        className={`progress-bar progress-bar-${bar}`}
                        style={{ width: benchmark >= 0 ? `${benchmark}%` : '0%' }}
                    />
                </div>
            )}
        </div>
    );
};

export default Rater;
